module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "top-bar",
    on: {
      "click": function($event) {
        return _vm.$refs.input.focus()
      }
    }
  }, [_c('div', {
    ref: "ruler",
    staticClass: "ruler"
  }), _vm._v(" "), _c('div', {
    ref: "wrapper",
    staticClass: "input-wrapper"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.hasUserSelectedText),
      expression: "!hasUserSelectedText"
    }],
    ref: "caret",
    staticClass: "caret"
  }), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.text),
      expression: "text"
    }],
    ref: "input",
    class: 'input rows-' + _vm.rows,
    attrs: {
      "spellcheck": "false",
      "autocomplete": "off",
      "autocorrect": "off",
      "autocapitalize": "off",
      "rows": _vm.rows,
      "autofocus": ""
    },
    domProps: {
      "value": (_vm.text)
    },
    on: {
      "mouseup": _vm.onInputMouseUp,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.text = $event.target.value
      }
    }
  })])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-4e2ed5fd!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/TopBar.vue
// module id = 32
// module chunks = 0